/* ═══════════════════════════════════════════════════════════════════
   RING BUILDER — Bijoux Luxo
   Shopify-native engagement ring configurator.
   Consultation-first: Build → Review → Consult → Draft Order
   ═══════════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ═══ PROVIDER ADAPTER LAYER ═══
     Normalizes supplier data into Luxo schema.
     Currently: Stuller (hardcoded catalog).
     Future: Nivoda, VDB via API fetch.
     Frontend always reads from the normalized RINGS array. */

  var ProviderAdapter = {
    providers: {},

    register: function(name, adapter) {
      this.providers[name] = adapter;
    },

    normalize: function(providerName, rawData) {
      var adapter = this.providers[providerName];
      if (!adapter) return [];
      return rawData.map(adapter.normalize);
    },

    /* Luxo canonical schema for a ring setting */
    schema: {
      id: '',           // Luxo internal ID (e.g., 'cushion-solitaire')
      title: '',        // Display name
      shape: '',        // Diamond shape this setting accepts
      style: '',        // Solitaire, Halo, Hidden Halo, etc.
      price: 0,         // CAD, setting price LIVE on the product page
      compareAt: 0,     // CAD, the struck-through was-price. 0 means not on sale.
      image: '',        // CDN URL
      url: '',          // Product page URL
      provider: '',     // Source provider ('stuller', 'nivoda', 'vdb', 'luxo')
      providerSku: '',  // Original SKU from provider
      metalOptions: [], // Available metals
      karatOptions: []  // Available karats (10KT, 14KT, 18KT)
    }
  };

  /* Stuller adapter (current catalog, hardcoded) */
  ProviderAdapter.register('stuller', {
    normalize: function(item) {
      return {
        id: item.id,
        title: item.title,
        shape: item.shape,
        style: item.style,
        price: item.price,
        compareAt: item.compareAt || 0,
        image: item.image,
        url: item.url,
        provider: 'stuller',
        providerSku: item.providerSku || '',
        metalOptions: item.metalOptions || ['Yellow Gold', 'White Gold', 'Rose Gold'],
        karatOptions: item.karatOptions || ['10KT', '14KT']
      };
    }
  });

  /* Future: Nivoda adapter
  ProviderAdapter.register('nivoda', {
    normalize: function(item) {
      return {
        id: 'niv-' + item.stockNumber,
        title: item.certificate.shape + ' ' + item.certificate.carats + 'ct',
        shape: item.certificate.shape,
        style: 'Loose Diamond',
        price: Math.round(item.price.totalPrice * 1.35),
        image: item.image,
        url: '',
        provider: 'nivoda',
        providerSku: item.stockNumber,
        metalOptions: [],
        karatOptions: []
      };
    }
  }); */


  /* ═══ PRODUCT DATA ═══
     19 curated ring settings with real Shopify CDN images and product URLs.
     All sourced via Stuller adapter normalization. */

  var RAW_STULLER_CATALOG = [
    {id:'cushion-solitaire', title:'Cushion Solitaire', shape:'Cushion', style:'Solitaire', price:2880,compareAt:3600, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/classic-four-prong-cushion-solitaire-lab-diamond-engagement-ring-bijoux-luxo-white-gold-3-565515.png?v=1763686155', url:'https://bijouxluxo.com/products/classic-four-prong-cushion-solitaire-engagement-ring'},
    {id:'cushion-classic', title:'Cushion Classic', shape:'Cushion', style:'Classic', price:4320,compareAt:5400, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/classic-four-prong-cushion-lab-diamond-engagement-ring-bijoux-luxo-3-yellow-gold-243617.png?v=1763686194', url:'https://bijouxluxo.com/products/classic-four-prong-cushion-engagement-ring'},
    {id:'round-solitaire-4prong', title:'Round Solitaire (Four Prong)', shape:'Round', style:'Solitaire', price:3360,compareAt:4200, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/classic-four-prong-round-lab-diamond-solitaire-engagement-ring-bijoux-luxo-3-white-gold-285421.png?v=1763704302', url:'https://bijouxluxo.com/products/classic-four-prong-round-solitaire-engagement-ring-copy'},
    {id:'round-solitaire-6prong', title:'Round Solitaire (Six Prong)', shape:'Round', style:'Solitaire', price:3456,compareAt:4320, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/classic-six-prong-round-solitaire-lab-diamond-engagement-ring-bijoux-luxo-yellow-gold-3-870448.png?v=1763704238', url:'https://bijouxluxo.com/products/classic-six-prong-round-solitaire-engagement-ring'},
    {id:'marquise-hidden-halo', title:'Marquise Hidden Halo', shape:'Marquise', style:'Hidden Halo', price:3360,compareAt:4200, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/classic-six-prong-marquise-lab-diamond-engagement-ring-with-hidden-halo-bijoux-luxo-yellow-gold-3-446704.png?v=1763686240', url:'https://bijouxluxo.com/products/classic-six-prong-marquise-engagement-ring-with-hidden-halo'},
    {id:'emerald-bezel', title:'Emerald Bezel', shape:'Emerald', style:'Bezel', price:3760,compareAt:4700, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/emerald-bezel-lab-diamond-engagement-ring-bijoux-luxo-3-yellow-gold-135684.png?v=1763686122', url:'https://bijouxluxo.com/products/emerald-bezel-engagement-ring'},
    {id:'emerald-halo', title:'Emerald Halo', shape:'Emerald', style:'Halo', price:4800,compareAt:6000, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/emerald-halo-lab-diamond-engagement-ring-bijoux-luxo-3-white-gold-224920.jpg?v=1770245383', url:'https://bijouxluxo.com/products/halo-emerald-engagement-ring'},
    {id:'emerald-hidden-halo', title:'Emerald Hidden Halo', shape:'Emerald', style:'Hidden Halo', price:4800,compareAt:6000, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/emerald-lab-diamond-engagement-ring-bijoux-luxo-white-gold-3-594766.png?v=1763686172', url:'https://bijouxluxo.com/products/emerald-engagement-ring-with-hidden-halo'},
    {id:'heart-halo', title:'Heart Halo', shape:'Heart', style:'Halo', price:3840,compareAt:4800, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/halo-heart-lab-diamond-engagement-ring-with-hidden-halo-bijoux-luxo-white-gold-3-467738.png?v=1763686208', url:'https://bijouxluxo.com/products/halo-heart-engagement-ring-with-hidden-halo'},
    {id:'pear-halo', title:'Pear Halo', shape:'Pear', style:'Halo', price:4800,compareAt:6000, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/halo-pear-lab-diamond-engagement-ring-bijoux-luxo-yellow-gold-3-538581.png?v=1763704273', url:'https://bijouxluxo.com/products/halo-pear-engagement-ring-1'},
    {id:'round-halo', title:'Round Halo', shape:'Round', style:'Halo', price:4800,compareAt:6000, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/halo-round-lab-diamond-engagement-ring-bijoux-luxo-white-gold-3-214624.png?v=1763704277', url:'https://bijouxluxo.com/products/halo-round-engagement-ring'},
    {id:'oval-classic', title:'Oval Classic', shape:'Oval', style:'Classic', price:3360,compareAt:4200, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/oval-lab-diamond-engagement-ring-bijoux-luxo-yellow-gold-3-248157.png?v=1763686204', url:'https://bijouxluxo.com/products/oval-engagement-ring-with-hidden-halo-copy-1'},
    {id:'oval-hidden-halo', title:'Oval Hidden Halo', shape:'Oval', style:'Hidden Halo', price:3648,compareAt:4560, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/oval-lab-diamond-engagement-ring-with-hidden-halo-bijoux-luxo-3-yellow-gold-103893.png?v=1763686160', url:'https://bijouxluxo.com/products/oval-engagement-rings-with-hidden-halo'},
    {id:'oval-hidden-halo-premium', title:'Oval Hidden Halo (Premium)', shape:'Oval', style:'Hidden Halo', price:4800,compareAt:6000, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/oval-lab-diamond-engagement-ring-with-hidden-halo-bijoux-luxo-3-white-gold-130201.png?v=1763686215', url:'https://bijouxluxo.com/products/oval-engagement-ring-copy'},
    {id:'princess-classic', title:'Princess Cut Classic', shape:'Princess', style:'Classic', price:4320,compareAt:5400, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/princess-cut-lab-diamond-engagement-ring-bijoux-luxo-white-gold-3-135760.png?v=1763704326', url:'https://bijouxluxo.com/products/princess-cut-engagement-ring'},
    {id:'princess-hidden-halo', title:'Princess Hidden Halo', shape:'Princess', style:'Hidden Halo', price:3648,compareAt:4560, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/princess-cut-solitaire-lab-diamond-engagement-ring-with-hidden-halo-bijoux-luxo-3-white-gold-875514.png?v=1763704255', url:'https://bijouxluxo.com/products/princess-cut-solitaire-engagement-ring'},
    {id:'round-hidden-halo', title:'Round Hidden Halo', shape:'Round', style:'Hidden Halo', price:3648,compareAt:4560, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/round-solitaire-lab-diamond-engagement-ring-with-hidden-halo-bijoux-luxo-white-gold-3-152861.png?v=1763769576', url:'https://bijouxluxo.com/products/three-stone-radiant-engagement-ring-copy'},
    {id:'round-hidden-halo-premium', title:'Round Hidden Halo (Premium)', shape:'Round', style:'Hidden Halo', price:4800,compareAt:6000, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/round-solitaire-lab-diamond-engagement-ring-with-hidden-halo-bijoux-luxo-white-gold-3-961901.png?v=1763704334', url:'https://bijouxluxo.com/products/classic-four-prong-round-solitaire-engagement-ring-copy-1'},
    {id:'asscher-three-stone', title:'Asscher Three Stone', shape:'Asscher', style:'Three Stone', price:4800,compareAt:6000, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/three-stone-asscher-lab-diamond-engagement-ring-bijoux-luxo-white-gold-3-626605.png?v=1763704306', url:'https://bijouxluxo.com/products/three-stone-asscher-engagement-ring'},
    {id:'marquise-three-stone', title:'Marquise Three Stone', shape:'Marquise', style:'Three Stone', price:2880,compareAt:3600, image:'https://cdn.shopify.com/s/files/1/0092/1311/6521/files/three-stone-marquise-lab-diamond-engagement-ring-bijoux-luxo-white-gold-3-938646.png?v=1763686103', url:'https://bijouxluxo.com/products/three-stone-marquise-engagement-ring'}
  ];

  var RINGS = ProviderAdapter.normalize('stuller', RAW_STULLER_CATALOG);

  var SHAPES = [
    {name:'Round',    icon:'\u25CB', desc:'Maximum brilliance. The most popular choice.'},
    {name:'Oval',     icon:'\u2B2D', desc:'Elongating and elegant on the finger.'},
    {name:'Cushion',  icon:'\u25A2', desc:'Romantic with rounded corners and fire.'},
    {name:'Emerald',  icon:'\u25AD', desc:'Art deco sophistication with hall-of-mirrors effect.'},
    {name:'Princess', icon:'\u25C7', desc:'Modern and geometric. Second most popular.'},
    {name:'Pear',     icon:'\u25C6', desc:'Unique teardrop silhouette.'},
    {name:'Marquise', icon:'\u25C8', desc:'Dramatic and elongating with vintage appeal.'},
    {name:'Asscher',  icon:'\u25A3', desc:'Step-cut clarity with an art deco soul.'},
    {name:'Heart',    icon:'\u2661', desc:'The ultimate symbol of love.'}
  ];


  /* ═══ STATE ═══ */

  var state = {
    step: 1,
    filter: 'all',
    ring: null,
    shape: null,
    metal: 'Yellow Gold',
    size: '',
    consultType: 'Video Call',
    refId: generateRefId()
  };

  var STORAGE_KEY = 'bl-er-state';
  var CONSULT_KEY = 'bl-er-consultations';
  var SAVED_KEY = 'bl-er-saved';


  /* ═══ UTILITIES ═══ */

  function generateRefId() {
    return 'BL-ER-' + String(Math.floor(10000 + Math.random() * 90000));
  }

  /* How much price the customer sees.
       'consultation'  - no numbers at all, book a call to find out
       'starting_from' - the setting price, framed as a floor
       'exact'         - the setting price as-is, with the was-price struck through

     Changed from 'consultation' to 'starting_from' on 2026-09-14. Two reasons,
     both measured rather than assumed. First, the engagement rings now carry a
     real sale (20% off, compareAt set on every variant), and a builder that
     hides it throws away the only concrete reason to act that the page has.
     Second, this brand's own send history says vagueness does not convert:
     offer campaigns earn about 5x more per recipient than editorial ones, and
     21 of 27 campaigns that gave no specific reason to act earned nothing at
     all. Asking a stranger to fill in a form before learning what anything
     costs is the same mistake in a different medium.

     The diamond is still quoted in consultation, which is the honest part: its
     price genuinely depends on the stone. What the customer gets here is the
     setting price, which we know exactly. */
  var PRICING_MODE = 'starting_from'; // 'consultation' | 'starting_from' | 'exact'

  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-CA');
  }

  /* Customer-facing price for one setting. Returns an object rather than a
     string so the caller can render the was-price as real strikethrough markup
     instead of shipping HTML out of a formatter. */
  function priceParts(ring) {
    var p = ring && ring.price ? ring.price : 0;
    var was = ring && ring.compareAt ? ring.compareAt : 0;

    if (PRICING_MODE === 'consultation' || !p) {
      return { label: 'Price shared during consultation', was: null, note: null };
    }
    if (PRICING_MODE === 'exact') {
      return { label: money(p), was: was > p ? money(was) : null, note: 'setting only' };
    }
    // starting_from
    return {
      label: 'Setting from ' + money(p),
      was: was > p ? money(was) : null,
      note: 'diamond priced separately'
    };
  }

  /* Kept for callers that still want a plain string. */
  function formatPricePublic(ring) {
    return priceParts(ring).label;
  }

  /* The price block on a setting card. Escapes nothing because every value
     comes from our own catalog constants, never from user input. */
  function priceHtml(ring) {
    var pp = priceParts(ring);
    var out = '<p class="rb-card__price">' + pp.label;
    if (pp.was) {
      out += ' <s class="rb-card__was">' + pp.was + '</s>';
    }
    out += '</p>';
    if (pp.note) {
      out += '<p class="rb-card__pricenote">' + pp.note + '</p>';
    }
    return out;
  }

  function formatPriceInternal(p) {
    if (!p || p === 0) return null;
    return '$' + p.toLocaleString('en-CA') + ' CAD';
  }

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }


  /* ═══ UTM CAPTURE ═══ */

  function getUTM(param) {
    try {
      var url = new URL(window.location.href);
      return url.searchParams.get(param) || null;
    } catch(e) { return null; }
  }


  /* ═══ CRM-READY DESIGN RECORD ═══
     Full consultation-first data model.
     Every consultation request creates this record in localStorage.
     Luxo reviews internally, then sends Draft Order / invoice manually. */

  function buildDesignRecord(customerData) {
    var ring = state.ring;
    var now = new Date().toISOString();
    return {
      // Identity
      design_reference: state.refId,
      created_at: now,
      updated_at: now,

      // Customer / Lead
      customer_name: customerData.name || null,
      customer_email: customerData.email || null,
      customer_phone: customerData.phone || null,

      // Consultation
      consultation_status: customerData.name ? 'requested' : 'saved',
      consultation_requested_at: customerData.name ? now : null,
      consultation_type: customerData.consultType || null,
      consultation_preferred_date: customerData.preferredDate || null,
      consultation_notes: customerData.message || '',

      // Selected Setting
      selected_setting_id: ring ? ring.id : null,
      selected_setting_name: ring ? ring.title : null,
      selected_setting_style: ring ? ring.style : null,
      selected_setting_metal: state.metal,
      selected_setting_shape: state.shape || null,

      // Selected Diamond (preferences, not exact stone)
      selected_diamond_id: null,
      selected_diamond_type: 'Lab-Grown',
      selected_diamond_shape: state.shape || null,
      selected_diamond_carat: '1.00+',
      selected_diamond_color: 'D-F',
      selected_diamond_clarity: 'VS+',
      selected_diamond_cut: null,
      selected_diamond_cert: 'IGI',

      // Ring
      ring_size: state.size || null,

      // Pricing (internal only, never shown to customer)
      pricing_visibility_mode: PRICING_MODE,
      _internal_setting_price: ring ? ring.price : null,
      _internal_currency: 'CAD',

      // Supplier
      supplier_source: ring ? ring.provider : null,
      supplier_sku: ring ? ring.providerSku : null,

      // Attribution
      source_url: window.location.href,
      utm_source: getUTM('utm_source'),
      utm_medium: getUTM('utm_medium'),
      utm_campaign: getUTM('utm_campaign'),

      // Internal
      internal_notes: '',
      source: 'ring-builder-v2',
      product_url: ring ? ring.url : null,
      product_image: ring ? ring.image : null
    };
  }


  /* ═══ PERSISTENCE ═══ */

  function persist() {
    try {
      var data = {
        ring: state.ring ? state.ring.id : null,
        shape: state.shape,
        metal: state.metal,
        size: state.size,
        consultType: state.consultType,
        refId: state.refId,
        filter: state.filter
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch(e) { /* silent */ }
  }

  function restore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data.ring) {
        state.ring = RINGS.find(function(r) { return r.id === data.ring; }) || null;
      }
      if (data.shape) state.shape = data.shape;
      if (data.metal) state.metal = data.metal;
      if (data.size) state.size = data.size;
      if (data.consultType) state.consultType = data.consultType;
      if (data.refId) state.refId = data.refId;
      if (data.filter) state.filter = data.filter;
    } catch(e) { /* silent */ }
  }


  /* ═══ STEP NAVIGATION ═══ */

  function goToStep(n) {
    if (n === 2 && !state.ring) return;
    if (n === 3 && (!state.ring || !state.shape)) return;
    if (n === 4 && (!state.ring || !state.shape)) return;

    state.step = n;

    // Show/hide panels
    $$('.rb-panel').forEach(function(p) {
      p.style.display = (parseInt(p.getAttribute('data-panel')) === n) ? '' : 'none';
    });

    // Update stepper
    $$('.rb-stepper__node').forEach(function(node) {
      var step = parseInt(node.getAttribute('data-goto'));
      node.classList.remove('active', 'completed');
      if (step === n) node.classList.add('active');
      else if (step < n) node.classList.add('completed');
    });

    // Render step content
    if (n === 2) renderStep2();
    if (n === 3) renderReview();
    if (n === 4) renderConsultation();

    // Update mobile bar
    updateMobileBar();

    // Update URL hash
    history.replaceState(null, '', '#step-' + n);

    // Scroll to top of builder
    var el = $('#ring-builder');
    if (el) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({top: top, behavior: 'smooth'});
    }

    // Track
    trackEvent('ring_builder_step', {step: n});
  }


  /* ═══ STEP 1: SETTINGS GRID ═══ */

  function renderSettings() {
    var grid = $('#rb-settings-grid');
    if (!grid) return;

    var rings = state.filter === 'all'
      ? RINGS
      : RINGS.filter(function(r) { return r.style === state.filter; });

    var html = rings.map(function(ring) {
      var selected = state.ring && state.ring.id === ring.id;
      return '<div class="rb-card' + (selected ? ' selected' : '') + '" data-ring="' + ring.id + '">' +
        '<div class="rb-card__check">\u2713</div>' +
        '<div class="rb-card__image">' +
          '<img src="' + ring.image + '" alt="' + ring.title + ' engagement ring" loading="lazy" width="400" height="400">' +
        '</div>' +
        '<div class="rb-card__info">' +
          '<p class="rb-card__style">' + ring.style + '</p>' +
          '<p class="rb-card__title">' + ring.title + '</p>' +
          priceHtml(ring) +
          '<span class="rb-card__cta">Select This Setting</span>' +
        '</div>' +
      '</div>';
    }).join('');

    grid.innerHTML = html;
  }

  function selectRing(id) {
    var ring = RINGS.find(function(r) { return r.id === id; });
    if (!ring) return;

    state.ring = ring;
    persist();

    // Visual feedback
    $$('.rb-card').forEach(function(c) {
      c.classList.toggle('selected', c.getAttribute('data-ring') === id);
    });

    // Auto-advance to step 2
    setTimeout(function() { goToStep(2); }, 300);

    trackEvent('ring_builder_setting_selected', {
      setting: ring.title,
      style: ring.style,
      provider: ring.provider
    });
  }


  /* ═══ STEP 2: DIAMOND & OPTIONS ═══ */

  function renderStep2() {
    renderShapes();
    renderMetals();
    renderSizeSelect();
    updateSummary();
  }

  function renderShapes() {
    var grid = $('#rb-shapes-grid');
    if (!grid) return;

    var selectedStyle = state.ring ? state.ring.style : null;
    var availableShapes = [];

    if (selectedStyle) {
      var seen = {};
      RINGS.forEach(function(r) {
        if (r.style === selectedStyle && !seen[r.shape]) {
          availableShapes.push(r.shape);
          seen[r.shape] = true;
        }
      });
    }

    var html = SHAPES.map(function(shape) {
      var available = availableShapes.indexOf(shape.name) !== -1;
      var active = state.shape === shape.name;
      var cls = 'rb-shape';
      if (active) cls += ' active';
      if (!available) cls += ' disabled';

      return '<button class="' + cls + '" data-shape="' + shape.name + '" type="button"' +
        (!available ? ' disabled' : '') + '>' +
        '<span class="rb-shape__icon">' + shape.icon + '</span>' +
        '<span class="rb-shape__name">' + shape.name + '</span>' +
        '<span class="rb-shape__desc">' + shape.desc + '</span>' +
      '</button>';
    }).join('');

    grid.innerHTML = html;

    // If current shape not available for this style, auto-select the ring's shape
    if (state.ring && availableShapes.indexOf(state.shape) === -1) {
      selectShape(state.ring.shape);
    }
  }

  function selectShape(name) {
    var selectedStyle = state.ring ? state.ring.style : null;
    var match = RINGS.find(function(r) {
      return r.shape === name && r.style === selectedStyle;
    });
    if (!match) return;

    state.shape = name;
    state.ring = match;
    persist();

    $$('.rb-shape').forEach(function(s) {
      s.classList.toggle('active', s.getAttribute('data-shape') === name);
    });

    updateSummary();

    trackEvent('ring_builder_shape_selected', {shape: name});
  }

  function renderMetals() {
    $$('.rb-metal').forEach(function(btn) {
      btn.classList.toggle('active', btn.getAttribute('data-metal') === state.metal);
    });
  }

  function selectMetal(name) {
    state.metal = name;
    persist();

    $$('.rb-metal').forEach(function(btn) {
      btn.classList.toggle('active', btn.getAttribute('data-metal') === name);
    });

    updateSummary();
    trackEvent('ring_builder_metal_selected', {metal: name});
  }

  function renderSizeSelect() {
    var sel = $('#rb-size');
    if (sel && state.size) {
      sel.value = state.size;
    }
  }

  function selectSize(value) {
    state.size = value;
    persist();
    updateSummary();
  }


  /* ═══ SUMMARY SIDEBAR ═══ */

  function updateSummary() {
    var ring = state.ring;
    if (!ring) return;

    var thumb = $('#rb-summary-thumb');
    if (thumb) {
      thumb.innerHTML = '<img src="' + ring.image + '" alt="' + ring.title + '" width="72" height="72">';
    }

    var titleEl = $('#rb-summary-title');
    if (titleEl) titleEl.textContent = ring.title;

    var styleEl = $('#rb-summary-style');
    if (styleEl) styleEl.textContent = ring.style;

    var setting = $('#rb-sum-setting');
    if (setting) setting.textContent = ring.title;

    var shape = $('#rb-sum-shape');
    if (shape) shape.textContent = state.shape || '--';

    var metal = $('#rb-sum-metal');
    if (metal) metal.textContent = state.metal;

    var size = $('#rb-sum-size');
    if (size) size.textContent = state.size || '--';

    var sumPrice = $('#rb-sum-price');
    if (sumPrice) {
      var pp = priceParts(ring);
      sumPrice.innerHTML = pp.was
        ? pp.label + ' <s class="rb-card__was">' + pp.was + '</s>'
        : pp.label;
    }

    updateMobileBar();
  }


  /* ═══ STEP 3: REVIEW DESIGN ═══ */

  function renderReview() {
    var ring = state.ring;
    if (!ring) return;

    var img = $('#rb-review-img');
    if (img) {
      img.src = ring.image;
      img.alt = ring.title + ' engagement ring design';
    }

    var tags = $('#rb-review-tags');
    if (tags) {
      var tagItems = [ring.style, state.shape, state.metal, 'Lab-Grown Diamond', 'IGI Certified'];
      tags.innerHTML = tagItems.map(function(t) {
        return '<span class="rb-review__tag">' + t + '</span>';
      }).join('');
    }

    var ref = $('#rb-review-ref');
    if (ref) ref.textContent = 'Design Reference: ' + state.refId;

    /* Show the setting's real price on the review step. Previously this box
       was static markup reading "Price shared during consultation", so a
       customer reached the final step still not knowing what anything cost. */
    var pp = priceParts(ring);
    var revPrice = $('#rb-rev-price');
    if (revPrice) {
      revPrice.innerHTML = pp.was
        ? pp.label + ' <s class="rb-card__was">' + pp.was + '</s>'
        : pp.label;
    }
    var revNote = $('#rb-rev-pricenote');
    if (revNote) {
      revNote.textContent = 'The diamond is priced separately. Your ring specialist confirms '
        + 'the stone and the final total during your complimentary consultation.';
    }

    var setting = $('#rb-rev-setting');
    if (setting) setting.textContent = ring.title;

    var shape = $('#rb-rev-shape');
    if (shape) shape.textContent = state.shape || '--';

    var metal = $('#rb-rev-metal');
    if (metal) metal.textContent = state.metal;

    var size = $('#rb-rev-size');
    if (size) size.textContent = state.size ? 'Size ' + state.size : 'Not selected';
  }


  /* ═══ STEP 4: CONSULTATION ═══ */

  function renderConsultation() {
    var ring = state.ring;
    if (!ring) return;

    // Design card thumbnail
    var thumb = $('#rb-consult-thumb');
    if (thumb) {
      thumb.innerHTML = '<img src="' + ring.image + '" alt="' + ring.title + '" width="120" height="120">';
    }

    // Design card rows
    var ref = $('#rb-consult-ref');
    if (ref) ref.textContent = state.refId;

    var setting = $('#rb-con-setting');
    if (setting) setting.textContent = ring.title;

    var shape = $('#rb-con-shape');
    if (shape) shape.textContent = state.shape || '--';

    var metal = $('#rb-con-metal');
    if (metal) metal.textContent = state.metal;

    var size = $('#rb-con-size');
    if (size) size.textContent = state.size ? 'Size ' + state.size : 'TBD';

    // Populate hidden form fields
    var fRef = $('#rb-f-ref');
    if (fRef) fRef.value = state.refId;

    var fSetting = $('#rb-f-setting');
    if (fSetting) fSetting.value = ring.title + ' (' + ring.style + ')';

    var fShape = $('#rb-f-shape');
    if (fShape) fShape.value = state.shape || '';

    var fMetal = $('#rb-f-metal');
    if (fMetal) fMetal.value = state.metal;

    var fSize = $('#rb-f-size');
    if (fSize) fSize.value = state.size || 'Not selected';

    var fPrice = $('#rb-f-price');
    if (fPrice) fPrice.value = formatPriceInternal(ring.price) || 'Consultation';

    var fUrl = $('#rb-f-url');
    if (fUrl) fUrl.value = ring.url;

    // Set min date to tomorrow
    var dateInput = $('#rb-q-preferred-date');
    if (dateInput) {
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      dateInput.min = tomorrow.toISOString().split('T')[0];
    }

    // Restore consultation type
    $$('.rb-consult-type').forEach(function(btn) {
      btn.classList.toggle('active', btn.getAttribute('data-type') === state.consultType);
    });
  }

  function handleConsultSubmit(e) {
    e.preventDefault();

    var form = e.target;
    var name = ($('#rb-q-name') || {}).value || '';
    var email = ($('#rb-q-email') || {}).value || '';
    var phone = ($('#rb-q-phone') || {}).value || '';
    var msg = ($('#rb-q-msg') || {}).value || '';
    var preferredDate = ($('#rb-q-preferred-date') || {}).value || '';

    // Clear errors
    var errName = $('#rb-err-name');
    var errEmail = $('#rb-err-email');
    var errPhone = $('#rb-err-phone');
    if (errName) errName.textContent = '';
    if (errEmail) errEmail.textContent = '';
    if (errPhone) errPhone.textContent = '';

    // Validate
    var valid = true;
    name = name.trim();
    email = email.trim();
    phone = phone.trim();

    if (!name) {
      if (errName) errName.textContent = 'Please enter your name.';
      valid = false;
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errEmail) errEmail.textContent = 'Please enter a valid email address.';
      valid = false;
    }
    if (!phone) {
      if (errPhone) errPhone.textContent = 'Please enter your phone number.';
      valid = false;
    }
    if (!valid) return;

    // Build CRM-ready design record
    var designRecord = buildDesignRecord({
      name: name,
      email: email,
      phone: phone,
      message: msg,
      consultType: state.consultType,
      preferredDate: preferredDate
    });

    // Build the body field with full design + consultation summary
    var bodyParts = [
      '--- Ring Builder Consultation Request ---',
      'Reference: ' + state.refId,
      '',
      'DESIGN:',
      'Setting: ' + (state.ring ? state.ring.title : 'N/A'),
      'Style: ' + (state.ring ? state.ring.style : 'N/A'),
      'Diamond Shape: ' + (state.shape || 'N/A'),
      'Metal: ' + state.metal,
      'Ring Size: ' + (state.size || 'Not selected'),
      'Product URL: ' + (state.ring ? state.ring.url : 'N/A'),
      'Provider: ' + (state.ring ? state.ring.provider : 'N/A'),
      'Internal Price Ref: ' + (formatPriceInternal(state.ring ? state.ring.price : 0) || 'N/A'),
      '',
      'CONSULTATION:',
      'Type: ' + state.consultType,
      'Preferred Date: ' + (preferredDate || 'Flexible'),
      'Customer Notes: ' + (msg || 'None'),
      '',
      'SOURCE:',
      'URL: ' + window.location.href,
      'UTM Source: ' + (getUTM('utm_source') || 'direct'),
      'UTM Medium: ' + (getUTM('utm_medium') || 'none'),
      'UTM Campaign: ' + (getUTM('utm_campaign') || 'none')
    ];

    // Update the body textarea with the full summary
    var msgField = $('#rb-q-msg');
    if (msgField) {
      msgField.value = bodyParts.join('\n');
    }

    // Save CRM record to localStorage
    try {
      var records = JSON.parse(localStorage.getItem(CONSULT_KEY) || '[]');
      records.push(designRecord);
      localStorage.setItem(CONSULT_KEY, JSON.stringify(records));
    } catch(ex) { /* silent */ }

    // Submit via AJAX to Shopify contact form
    var formData = new FormData(form);

    fetch('/contact', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    }).then(function() {
      showConsultSuccess();
    }).catch(function() {
      showConsultSuccess();
    });

    // Dispatch custom event for Klaviyo/GA4
    var event = new CustomEvent('ringBuilder:consultationRequested', {
      detail: {
        refId: state.refId,
        setting: state.ring ? state.ring.title : '',
        shape: state.shape,
        metal: state.metal,
        size: state.size,
        consultType: state.consultType,
        customerEmail: email
      }
    });
    document.dispatchEvent(event);

    trackEvent('ring_builder_consultation_requested', {
      ref_id: state.refId,
      setting: state.ring ? state.ring.title : '',
      consult_type: state.consultType
    });
  }

  function showConsultSuccess() {
    var formEl = $('#rb-consult-form');
    var successEl = $('#rb-consult-success');
    var refEl = $('#rb-success-ref');

    if (formEl) formEl.style.display = 'none';
    if (successEl) successEl.style.display = '';
    if (refEl) refEl.textContent = state.refId;
  }


  /* ═══ SAVE DESIGN ═══ */

  function saveDesign() {
    var design = buildDesignRecord({});

    try {
      var saved = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]');
      saved.push(design);
      localStorage.setItem(SAVED_KEY, JSON.stringify(saved));
    } catch(ex) { /* silent */ }

    var btn = $('#rb-save-btn');
    if (btn) {
      var original = btn.textContent;
      btn.textContent = 'Design Saved \u2713';
      btn.disabled = true;
      setTimeout(function() {
        btn.textContent = original;
        btn.disabled = false;
      }, 2500);
    }

    // Dispatch event for Klaviyo
    var ring = state.ring;
    var event = new CustomEvent('ringBuilder:designSaved', {
      detail: {
        refId: state.refId,
        setting: ring ? ring.title : '',
        shape: state.shape,
        metal: state.metal
      }
    });
    document.dispatchEvent(event);

    trackEvent('ring_builder_design_saved', {ref_id: state.refId});
  }


  /* ═══ MOBILE BAR ═══ */

  function updateMobileBar() {
    var statusEl = $('#rb-mobile-status');
    var ctaEl = $('#rb-mobile-cta');
    if (!ctaEl) return;

    var ring = state.ring;
    if (statusEl) {
      statusEl.textContent = ring ? ring.title : 'Design Your Ring';
    }

    switch (state.step) {
      case 1:
        ctaEl.textContent = 'Continue';
        ctaEl.disabled = !state.ring;
        break;
      case 2:
        ctaEl.textContent = 'Review Design';
        ctaEl.disabled = !state.shape;
        break;
      case 3:
        ctaEl.textContent = 'Book Consultation';
        ctaEl.disabled = false;
        break;
      case 4:
        ctaEl.textContent = 'Request Consultation';
        ctaEl.disabled = false;
        break;
    }
  }

  function handleMobileCta() {
    switch (state.step) {
      case 1:
        if (state.ring) goToStep(2);
        break;
      case 2:
        if (state.shape) goToStep(3);
        break;
      case 3:
        goToStep(4);
        break;
      case 4:
        var nameInput = $('#rb-q-name');
        if (nameInput) nameInput.focus();
        break;
    }
  }


  /* ═══ RESET ═══ */

  function resetBuilder() {
    state.ring = null;
    state.shape = null;
    state.metal = 'Yellow Gold';
    state.size = '';
    state.consultType = 'Video Call';
    state.refId = generateRefId();
    state.filter = 'all';

    try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}

    // Reset filter buttons
    $$('.rb-filter').forEach(function(btn) {
      btn.classList.toggle('active', btn.getAttribute('data-filter') === 'all');
    });

    // Show consultation form, hide success
    var formEl = $('#rb-consult-form');
    var successEl = $('#rb-consult-success');
    if (formEl) formEl.style.display = '';
    if (successEl) successEl.style.display = 'none';

    // Clear form fields
    var nameField = $('#rb-q-name');
    var emailField = $('#rb-q-email');
    var phoneField = $('#rb-q-phone');
    var msgField = $('#rb-q-msg');
    var dateField = $('#rb-q-preferred-date');
    if (nameField) nameField.value = '';
    if (emailField) emailField.value = '';
    if (phoneField) phoneField.value = '';
    if (msgField) msgField.value = '';
    if (dateField) dateField.value = '';

    // Reset consultation type
    $$('.rb-consult-type').forEach(function(btn) {
      btn.classList.toggle('active', btn.getAttribute('data-type') === 'Video Call');
    });
    var fConsultType = $('#rb-f-consult-type');
    if (fConsultType) fConsultType.value = 'Video Call';

    renderSettings();
    goToStep(1);
  }


  /* ═══ TRACKING ═══ */

  function trackEvent(name, data) {
    if (typeof gtag === 'function') {
      gtag('event', name, data || {});
    }
    if (typeof _learnq !== 'undefined' && (name.indexOf('consultation') !== -1 || name.indexOf('design_saved') !== -1)) {
      _learnq.push(['track', 'Ring Builder: ' + name, data || {}]);
    }
  }


  /* ═══ URL HASH ROUTING ═══ */

  function handleHash() {
    var hash = window.location.hash;
    if (!hash) return;

    var match = hash.match(/^#step-(\d)$/);
    if (match) {
      var step = parseInt(match[1]);
      if (step >= 1 && step <= 4) {
        goToStep(step);
      }
    }
  }


  /* ═══ EVENT BINDING ═══ */

  function bindEvents() {
    // Filter buttons
    var filterBar = $('#rb-filters');
    if (filterBar) {
      filterBar.addEventListener('click', function(e) {
        var btn = e.target.closest('.rb-filter');
        if (!btn) return;
        state.filter = btn.getAttribute('data-filter');
        $$('.rb-filter').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        renderSettings();
        persist();
      });
    }

    // Settings grid (event delegation)
    var grid = $('#rb-settings-grid');
    if (grid) {
      grid.addEventListener('click', function(e) {
        var card = e.target.closest('.rb-card');
        if (!card) return;
        selectRing(card.getAttribute('data-ring'));
      });
    }

    // Shapes grid
    var shapesGrid = $('#rb-shapes-grid');
    if (shapesGrid) {
      shapesGrid.addEventListener('click', function(e) {
        var shape = e.target.closest('.rb-shape:not(.disabled)');
        if (!shape) return;
        selectShape(shape.getAttribute('data-shape'));
      });
    }

    // Metal swatches
    var metals = $('#rb-metals');
    if (metals) {
      metals.addEventListener('click', function(e) {
        var btn = e.target.closest('.rb-metal');
        if (!btn) return;
        selectMetal(btn.getAttribute('data-metal'));
      });
    }

    // Ring size
    var sizeSelect = $('#rb-size');
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function() {
        selectSize(this.value);
      });
    }

    // Stepper navigation
    $$('.rb-stepper__node').forEach(function(node) {
      node.addEventListener('click', function() {
        var step = parseInt(this.getAttribute('data-goto'));
        if (this.classList.contains('completed') || this.classList.contains('active')) {
          goToStep(step);
        }
      });
    });

    // Continue button (Step 2 sidebar)
    var continueBtn = $('#rb-continue');
    if (continueBtn) {
      continueBtn.addEventListener('click', function() {
        if (state.shape) goToStep(3);
      });
    }

    // Back button (Step 2 → Step 1)
    var backBtn1 = $('#rb-back-1');
    if (backBtn1) {
      backBtn1.addEventListener('click', function() { goToStep(1); });
    }

    // Back button (Step 3 → Step 2)
    var backBtn2 = $('#rb-back-2');
    if (backBtn2) {
      backBtn2.addEventListener('click', function() { goToStep(2); });
    }

    // Back button (Step 4 → Step 3)
    var backBtn3 = $('#rb-back-3');
    if (backBtn3) {
      backBtn3.addEventListener('click', function() { goToStep(3); });
    }

    // Book consultation button (Step 3 → Step 4)
    var toConsult = $('#rb-to-consult');
    if (toConsult) {
      toConsult.addEventListener('click', function() { goToStep(4); });
    }

    // Mobile CTA
    var mobileCta = $('#rb-mobile-cta');
    if (mobileCta) {
      mobileCta.addEventListener('click', handleMobileCta);
    }

    // Consultation form
    var consultForm = $('#rb-consult-form form');
    if (consultForm) {
      consultForm.addEventListener('submit', handleConsultSubmit);
    }

    // Consultation type selector
    var consultTypes = $('#rb-consult-types');
    if (consultTypes) {
      consultTypes.addEventListener('click', function(e) {
        var btn = e.target.closest('.rb-consult-type');
        if (!btn) return;
        var type = btn.getAttribute('data-type');
        state.consultType = type;
        persist();
        $$('.rb-consult-type').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var hidden = $('#rb-f-consult-type');
        if (hidden) hidden.value = type;
      });
    }

    // Save design button
    var saveBtn = $('#rb-save-btn');
    if (saveBtn) {
      saveBtn.addEventListener('click', saveDesign);
    }

    // Hash change
    window.addEventListener('hashchange', handleHash);
  }


  /* ═══ INIT ═══ */

  function init() {
    restore();
    renderSettings();
    updateMobileBar();

    // If restored state has selections, update filter
    if (state.filter !== 'all') {
      $$('.rb-filter').forEach(function(btn) {
        btn.classList.toggle('active', btn.getAttribute('data-filter') === state.filter);
      });
    }

    bindEvents();
    handleHash();

    trackEvent('ring_builder_viewed', {});
  }


  /* ═══ PUBLIC API ═══ */

  window.ringBuilder = {
    goToStep: goToStep,
    saveDesign: saveDesign,
    reset: resetBuilder,
    getDesignRecord: function() { return buildDesignRecord({}); },
    getState: function() { return JSON.parse(JSON.stringify(state)); },
    ProviderAdapter: ProviderAdapter
  };


  /* ═══ BOOT ═══ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
